import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

const AdVerbiage = styled.div`
  color: rgb(255, 255, 255);
  font-family: 'Pluto Sans SemiBold';
  font-size: 35px;
  letter-spacing: 0;
  position: relative;
  width: 90%;
  margin: 0 auto;
  margin-top: 12vh;
`;

function LocalizedNotification({ language, marketingRegion }) {
  const isUS = marketingRegion === 'us';
  const isSpain = marketingRegion === 'es';
  const isGerman = marketingRegion === 'gsa';
  const isBritain = marketingRegion === 'uk';
  const isLatam = marketingRegion === 'latam';
  const isBrazil = marketingRegion === 'br';
  const isFrance = marketingRegion === 'fr';

  if (isUS) {
    return (
      <AdVerbiage>
        Watch 100s of
        <br />
        channels free
      </AdVerbiage>
    );
  }

  if (isGerman) {
    if (language.includes('de')) {
      return (
        <AdVerbiage>
          Schaue 75+ Live TV Sender und
          <br />
          1.000+ Filme & Serien kostenlos.
        </AdVerbiage>
      );
    } else {
      return (
        <AdVerbiage>
          Watch 75+ of
          <br />
          channels free
        </AdVerbiage>
      );
    }
  }

  if (isBritain) {
    return (
      <AdVerbiage>
        Watch 75+ of
        <br />
        channels free
      </AdVerbiage>
    );
  }

  if (isSpain || isLatam) {
    if (language.includes('es')) {
      return (
        // temporary verbiage only for Spain viewers
        <AdVerbiage>
          Disfruta de peliculas
          <br />y programas de TV gratis
        </AdVerbiage>
      );
    } else {
      return (
        <AdVerbiage>
          Enjoy free movies
          <br />
          and TV shows
        </AdVerbiage>
      );
    }
  }

  if (isBrazil) {
    if (language.includes('pt')) {
      return (
        // temporary verbiage only for Spain viewers
        <AdVerbiage>
          Assista a canais
          <br />
          ao vivo e filmes
        </AdVerbiage>
      );
    } else {
      return (
        <AdVerbiage>
          Watch live channels
          <br />
          and movies
        </AdVerbiage>
      );
    }
  }

  if (isFrance) {
    if (language.includes('fr')) {
      return (
        <AdVerbiage>
          Regardez + de 40 chaînes
          <br />
          de télévision gratuitement
        </AdVerbiage>
      );
    } else {
      return (
        <AdVerbiage>
          Watch 40+
          <br />
          channels free
        </AdVerbiage>
      );
    }
  }

  return (
    <AdVerbiage>
      Watch 100s of
      <br />
      channels free
    </AdVerbiage>
  );
}

LocalizedNotification.propTypes = {
  language: PropTypes.string,
  marketingRegion: PropTypes.string,
};

export default LocalizedNotification;
